/**
 * @fileoverview Constants for the localization module.
 * @description The list of supported languages (shown in the language switcher), the default
 * language, the localStorage key the selected language is persisted under, and the default
 * locale/country used for Intl-based formatting (dates, numbers, currency).
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import type { LanguageCode, LanguageOption } from '@/shared/lib/i18n/language.types'

export const SUPPORTED_LANGUAGES: LanguageOption[] = [
  { code: 'en', nativeName: 'English' },
  { code: 'hi', nativeName: 'हिन्दी' },
  { code: 'mr', nativeName: 'मराठी' },
]

/**
 * Whether the language switcher is shown anywhere in the app. Switched off for now: the switcher
 * and its translations stay in place, so turning this back on to `true` brings the dropdown back
 * on the sign-in pages, the legal pages and the dashboard header.
 */
export const SHOW_LANGUAGE_SWITCHER = false

export const DEFAULT_LANGUAGE: LanguageCode = 'en'

export const LANGUAGE_STORAGE_KEY = 'brownbox.i18n.language'
